import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCredentials, setCredentials } from "../../authSlice";

function CollectionSheet6Months() {
  const { token } = useSelector((state) => state.auth);
  const [allCustomers, setAllCustomers] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedRange, setSelectedRange] = useState(1);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [tokenExpired, setTokenExpired] = useState(false);

  useEffect(() => {
    const fetchCustomers = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/getAllCustomers`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 401) {
          setTokenExpired(true);
          return;
        }

        if (response.ok) {
          const data = await response.json();
          const newAccessToken = response.headers.get("Authorization");
          if (newAccessToken) {
            dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
          }
          setAllCustomers(data.customers || []);
        } else {
          throw new Error("Failed to fetch customers.");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    if (!token || token === "null") {
      dispatch(setCredentials({ token: null, username: null }));
    }
    if (tokenExpired) {
      dispatch(clearCredentials());
      return;
    }
    if (token) {
      fetchCustomers();
    }
  }, [dispatch, token, tokenExpired]);

  const exportCollection = async () => {
    if (!selectedClient) {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/sales/getSalespdfonbasisofMonthRangeFilter?months=${selectedRange}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 401) {
          dispatch(clearCredentials());
          return;
        }

        if (response.ok) {
          const newAccessToken = response.headers.get("Authorization");
          if (newAccessToken) {
            dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
          }
          const blob = await response.blob();
          // Create a download URL for the blob
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          const filteredItems = allCustomers.filter(
            (customer) => customer._id === selectedClient
          );
          link.download = `Collection-${filteredItems[0].name}.pdf`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(downloadUrl);
        } else {
          throw new Error("Failed to fetch collection.");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/sales/getSalespdfonbasisofMonthRangeFilter?customerId=${selectedClient}&months=${selectedRange}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 401) {
          dispatch(clearCredentials());
          return
        }

        if (response.ok) {
          const newAccessToken = response.headers.get("Authorization");
          if (newAccessToken) {
            dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
          }
          const blob = await response.blob();
          // Create a download URL for the blob
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          const filteredItems = allCustomers.filter(
            (customer) => customer._id === selectedClient
          );
          link.download = `Collection-${filteredItems[0].name}.pdf`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(downloadUrl);
        } else {
          throw new Error("Failed to fetch collection.");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <div className="whiteBgDiv dashboardTablePadding">
        <div className="mainHeading">
          Export Collection Sheet (Previous 6 months)
        </div>
        <div className="descriptionText">
          Please choose a customer if you want to see collections from a
          specific customer, leave it bank otherwise.
        </div>
        <div
          className="d-flex flex-wrap flex-lg-nowrap"
          style={{ gap: "16px" }}
        >
          <div
            className="formInputLabelBox"
            style={{ flex: "1", minWidth: "250px" }}
          >
            <label>Client</label>
            <select
              name="client"
              className="form-select"
              value={selectedClient}
              onChange={(e) => setSelectedClient(e.target.value)}
            >
              <option value="">Choose Client</option>
              {allCustomers.map((customer) => (
                <option key={customer._id} value={customer._id}>
                  {customer.name}
                </option>
              ))}
            </select>
          </div>
          <div
            className="formInputLabelBox"
            style={{ flex: "1", minWidth: "250px" }}
          >
            <label>Months</label>
            <select
              name="area"
              className="form-select"
              value={selectedRange}
              onChange={(e) => setSelectedRange(e.target.value)}
            >
              {Array.from({ length: 6 }, (_, i) => i + 1).map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="UserManagementBtnFlexDiv">
          {loading ? (
            <button className="grayBtn">Loading...</button>
          ) : (
            <button className="colorBtn" onClick={exportCollection}>
              Export
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default CollectionSheet6Months;
